import * as React from "react";
import Box from "@mui/material/Box";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import EditIcon from "@mui/icons-material/Edit";
import dayjs from "dayjs";
import Chip from "@mui/material/Chip";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { setpreviewLogout } from "../../redux/slices/Preview";
import { setSelectedMeetingRooms } from "../../redux/slices/scheduleSectionSlice";
import LayoutItemList from "./LayoutItemList.js";
import MeetingRoomCard from "./MeetingRoomCard.js";
import {
  setSelectedLayout,
  setSelectedLayoutPlaylistItems,
} from "../../redux/slices/selectedLayoutSlice.js";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { setMeeting } from "../../redux/slices/meetingSlice.js";
import axios from "axios";
import { setSelectedContentAI } from "../../redux/slices/selectedContentAI.js";
import { setTemplateValues } from "../../redux/slices/templateValuesSlice.js";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function EditScheduleForm({
  open,
  handleEditModalClose,
  scheduleData,
}) {
  const dispatch = useDispatch();
  const layout = useSelector((state) => state?.layout?.layout);
  const playlist = useSelector((state) => state?.playlist?.playlist);
  const location = useSelector((state) => state.location.location);
  const headers = useSelector((state) => state.header);
  const emmsheaders = useSelector((state) => state.emmsheader);
  const curremms = useSelector((state) => state.curremms);
  const selectedOption = curremms.curremms.id;
  const locationIds = useSelector((state) => state?.schedule?.locationIds);
  const roomIds = useSelector((state) => state?.schedule?.roomIds);
  const templateValues = useSelector((state) => state.templateValues);
  const contentAI = useSelector((state) => state.selectedContentAI);
  const oldMeetingsData = useSelector((state) => state?.meeting?.meeting);
  const selectedLayoutId = useSelector(
    (state) => state?.selectedLayout?.selectedLayout?.layoutId?.id
  );

  const selectedLayout = useSelector(
    (state) => state?.selectedLayout?.selectedLayout
  );
  const selectedLayoutItems = useSelector(
    (state) => state.selectedLayout.selectedLayoutPlaylistItems
  );

  const api = localStorage.getItem("api");
  const user = useSelector((state) => state?.user?.user);
  const [formData, setFormData] = useState({
    startDate: null,
    endDate: null,
    startTime: null,
    endTime: null,
    name: "",
    user: "",
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [scheduleDateExpanded, setScheduleDateExpanded] = useState(false);
  const [locationsExpanded, setLocationsExpanded] = useState(false);

  useEffect(() => {
    if (scheduleData || scheduleData?.customProperties?.layoutId) {
      const startIST = dayjs.utc(scheduleData.startTime).tz("Asia/Kolkata");
      const endIST = dayjs.utc(scheduleData.endTime).tz("Asia/Kolkata");
      dispatch(setSelectedMeetingRooms(scheduleData.roomId));
      setFormData({
        startDate: startIST,
        endDate: endIST,
        startTime: startIST,
        endTime: endIST,
        name: scheduleData.name || "",
        user: scheduleData.user || "",
      });
    }
    if (scheduleData?.customProperties?.layoutId) {
      const matchingLayout = layout.find(
        (l) => l.id === scheduleData.customProperties.layoutId
      );

      if (matchingLayout) {
        const playlistId = matchingLayout.playlistId;
        const matchingPlaylist = playlist.find((p) => p.id === playlistId);

        dispatch(setSelectedLayout(matchingLayout));
        dispatch(setSelectedLayoutPlaylistItems(matchingPlaylist?.items || []));
      }
    }
    if (scheduleData?.customProperties) {
      const templateKey = Object.keys(
        scheduleData?.customProperties?.contentKey || {}
      ).find((key) => key.startsWith("template_"));
      const trimmedTemplateId = templateKey
        ? templateKey.replace("template_", "")
        : null;

      if (trimmedTemplateId) {
        dispatch(
          setTemplateValues({
            id: trimmedTemplateId,
            arguments:
              scheduleData?.customProperties?.contentKey?.[templateKey]
                ?.arguments || {},
            customProperties:
              scheduleData?.customProperties?.contentKey?.[templateKey]
                ?.customProperties || {},
          })
        );
      }

      dispatch(
        setSelectedContentAI({
          contentAI:
            scheduleData?.customProperties?.contentKey?.contentAI || {},
        })
      );
    }
  }, [scheduleData, open]);

  const handleDateChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const validateForm = () => {
    const { startDate, endDate, name, user, startTime, endTime } = formData;
    if (
      !name.trim() ||
      !user.trim() ||
      !startDate ||
      !endDate ||
      !startTime ||
      !endTime
    ) {
      toast.error("All fields are required.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return false;
    }
    if (dayjs(startDate).isAfter(dayjs(endDate))) {
      toast.error("Start Date must be before End Date.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return false;
    }
    return true;
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      toast.success("Schedule updated successfully.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }

    const meetingObject =
      JSON.parse(localStorage.getItem("meetingObject")) || {};

    const json = {
      id: scheduleData.id,
      ...meetingObject,
      startDate: dayjs(formData.startDate).format("YYYY-MM-DD"),
      endDate: dayjs(formData.endDate).format("YYYY-MM-DD"),
      startTime: dayjs(formData.startTime).format("HH:mm"),
      endTime: dayjs(formData.endTime).format("HH:mm"),
      name: formData.name,
      user: formData.user,
      roomIds,
      customProperties: {
        ...scheduleData.customProperties,
        contentKey: {
          ...Object.keys(templateValues).reduce((acc, key) => {
            if (key) {
              acc[`template_${key}`] = {
                arguments: {
                  ...templateValues[key].arguments,
                  event_name:
                    formData.name ||
                    templateValues[key].arguments.event_name ||
                    "",
                  host_name:
                    formData.user ||
                    templateValues[key].arguments.host_name ||
                    "",
                },
                customProperties: templateValues[key].customProperties,
              };
            }
            return acc;
          }, {}),
          contentAI: { ...contentAI },
        },
        layoutId: selectedLayoutId || scheduleData?.customProperties?.layoutId,
        linkageId: scheduleData?.customProperties?.linkageId,
        navigatorBooking: false,
        audit: {
          ...scheduleData.customProperties.audit,
          contentAiScheduleEditor: user?.email,
        },
      },
    };

    
    localStorage.setItem("meetingObject", JSON.stringify(json));

    const requestBody = {
      path: "singlemeetingupdate",
      query: {},
      body: json, 
      emmsId: `${selectedOption}`,
      requestType: "POST",
      headers: {
        ...emmsheaders?.emmsheaders?.headers,
      },
    };

    return axios
      .post(`${api}/emms/piggyback`, requestBody, headers)
      .then((response) => {
        const meetingMap = new Map(
          oldMeetingsData.map((meeting) => [meeting.id, meeting])
        );

        meetingMap.set(response.data.id, response.data);

        const combinedData = Array.from(meetingMap.values());

        dispatch(setMeeting(combinedData));
        toast.success("Updated successfully", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });

        return response.data;
      })
      .catch((error) => {
        console.log(error);
        toast.error("Error Creating Schedule", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        throw new Error(error.response?.data?.message || error.message);
      })
      .finally(() => {
        localStorage.setItem("meetingObject", JSON.stringify({}));
        handleEditModalClose();
      });
  };

  return (
    <Modal open={open} onClose={handleEditModalClose}>
      <Box sx={{
        width: "100vw",
        height: { xs: "100%" },
        display: "flex",
        flexDirection: "column",
        bgcolor: "background.paper",
        padding: 2,
        overflowY: "auto",
      }}>
        <Box
          sx={(theme) => ({
            p: 2,
            width: "100%",
            borderBottom: "1px solid #ddd",
            display: "flex",
            justifyContent: "space-between",

            [theme.breakpoints.down("md")]: {
              height: "8vh",
              alignItems: "center",
            },
          })}
        >
          <TextField
            label="Schedule Name"
            variant="standard"
            value={formData.name}
            onChange={(e) => handleDateChange("name", e.target.value)}
          />
          <TextField
            label="Host Name"
            variant="standard"
            value={formData.user}
            onChange={(e) => handleDateChange("user", e.target.value)}
          />
        </Box>

        <Box
          sx={(theme) => ({
            display: "flex",
            gap: 2,
            p: 2,

            [theme.breakpoints.down("md")]: {
              flex: 1,
              flexDirection: "column-reverse",
              gap: 0,
              p: 0,
              height: "50vh",
            },
          })}
        >
          <Box
            sx={(theme) => ({
              flex: 2.5,
              [theme.breakpoints.down("md")]: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              },
            })}
          >
            {isMobile ? (
              <Accordion
                expanded={scheduleDateExpanded}
                onChange={(_, isExpanded) => setScheduleDateExpanded(isExpanded)}
                disableGutters
                elevation={0}
                sx={{
                  borderRadius: 2,
                  width: "100%",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Chip
                    label="Schedule Date & Time"
                    sx={{
                      fontSize: ".8rem",
                      padding: "4px 12px",
                      borderRadius: "8px",
                    }}
                  />
                </AccordionSummary>

                <AccordionDetails>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Box sx={{ display: "flex", gap: 2, margin: "10px" }}>
                      <DatePicker
                        label="Start Date"
                        value={formData.startDate}
                        onChange={(value) => handleDateChange("startDate", value)}
                      />
                      <DatePicker
                        label="End Date"
                        value={formData.endDate}
                        onChange={(value) => handleDateChange("endDate", value)}
                      />
                    </Box>

                    <Box sx={{ display: "flex", gap: 2, margin: "10px" }}>
                      <TimePicker
                        label="Start Time"
                        value={formData.startTime}
                        onChange={(value) => handleDateChange("startTime", value)}
                      />
                      <TimePicker
                        label="End Time"
                        value={formData.endTime}
                        onChange={(value) => handleDateChange("endTime", value)}
                      />
                    </Box>
                  </LocalizationProvider>
                </AccordionDetails>
              </Accordion>
            ) : (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box sx={{ display: "flex", gap: 2, margin: "10px" }}>
                  <DatePicker
                    label="Start Date"
                    value={formData.startDate}
                    onChange={(value) => handleDateChange("startDate", value)}
                  />
                  <DatePicker
                    label="End Date"
                    value={formData.endDate}
                    onChange={(value) => handleDateChange("endDate", value)}
                  />
                </Box>

                <Box sx={{ display: "flex", gap: 2, margin: "10px" }}>
                  <TimePicker
                    label="Start Time"
                    value={formData.startTime}
                    onChange={(value) => handleDateChange("startTime", value)}
                  />
                  <TimePicker
                    label="End Time"
                    value={formData.endTime}
                    onChange={(value) => handleDateChange("endTime", value)}
                  />
                </Box>
              </LocalizationProvider>
            )}

            {isMobile ? (
              <Accordion
                expanded={locationsExpanded}
                onChange={(_, isExpanded) => setLocationsExpanded(isExpanded)}
                disableGutters
                elevation={0}
                sx={{
                  borderRadius: 2,
                  width: "100%",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Chip
                    label="Locations & Venues"
                    sx={{
                      fontSize: ".8rem",
                      padding: "4px 12px",
                      borderRadius: "8px",
                    }}
                  />
                </AccordionSummary>

                <AccordionDetails>
                  <MeetingRoomCard />
                </AccordionDetails>
              </Accordion>
            ) : (
              <Box
                sx={{
                  padding: "2px",
                  marginTop: { xs: "unset", md: "5vh" },
                  width: { xs: "unset", md: "30vw" },
                  textAlign: { xs: "center", md: "unset" },
                }}
              >
                <Chip
                  label="Locations & Venues"
                  sx={{
                    fontSize: ".8rem",
                    padding: "4px 12px",
                    borderRadius: "8px",
                  }}
                />
                <MeetingRoomCard />
              </Box>
            )}
          </Box>

          <Box
            sx={{
              flex: { xs: 8, md: 2 },
              maxHeight: "60vh",
              overflowY: "auto",
            }}
          >
            <Chip
              label="Select Layout"
              sx={(theme) => ({
                [theme.breakpoints.down("md")]: {
                  mt: 1,
                },
              })}
            />
            <LayoutItemList />
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
            p: 2,
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            variant="outlined"
            onClick={handleEditModalClose}
            color="error"
            sx={{ textTransform: "none" }}
          >
            Close
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={handleUpdate}
            sx={{ textTransform: "none" }}
          >
            Update
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
